import React from 'react';
import { List, Filter, Edit, Create, Show, SimpleShowLayout, Datagrid, NumberField, NumberInput, SingleFieldList, ChipField, ReferenceArrayField, ShowButton, ImageField, ImageInput, TextField, EditButton, DisabledInput, SimpleForm, TextInput } from 'admin-on-rest';

const MealsCategoriesFilters = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="query" alwaysOn />
    </Filter>
);

export const MealCategoriesList = (props) => (
    <List {...props} title="Meals Categories list" filters={<MealsCategoriesFilters />}>
        <Datagrid>
            <TextField source="name" />
            <ImageField source="thumbnail.url" label="thumbnail" />
            <NumberField source="index" />
            <ShowButton />
            <EditButton />
        </Datagrid>
    </List>
);

const MealCategoriesTitle = ({ record }) => {
    return <span>Meals Category {record ? `"${record.name}"` : ''}</span>;
};

export const MealCategoriesEdit = (props) => (
    <Edit {...props} title={<MealCategoriesTitle />}>
        <SimpleForm>
            <DisabledInput source="id" />
            <TextInput source="name" />
            <NumberInput source="index" />
            <ImageInput source="thumbnail" label="Thumbnail" accept="image/*" multiple={false}>
                <ImageField source="url" />
            </ImageInput>
        </SimpleForm>
    </Edit>
);

export const MealCategoriesCreate = (props) => (
    <Create {...props} title="Create Meal Category">
        <SimpleForm>
            <TextInput source="name" />
            <NumberInput source="index" />
            <ImageInput source="thumbnail" label="Thumbnail" accept="image/*">
                <ImageField source="url" />
            </ImageInput>
        </SimpleForm>
    </Create>
);

export const MealCategoriesShow = (props) => (
    <Show {...props} title={<MealCategoriesTitle />}>
        <SimpleShowLayout>
            <TextField source="name" />
            <TextField source="index" />
            <ImageField source="thumbnail.url" label="Thumbnail" />
            <ReferenceArrayField label="Meals" source="meals" reference="meals">
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>
            </ReferenceArrayField>
        </SimpleShowLayout>
    </Show>
);


// WEBPACK FOOTER //
// ./src/resources/mealCategories.js